import { FaExternalLinkAlt } from "react-icons/fa";
import { useMediaQuery } from "react-responsive";

import "./AllCertifications.css";
import { CERTIFICATIONS } from "../../data";
import DetailsLayout from "../details-layout/DetailsLayout";
import CertificationCard from "../certification-card/CertificationCard";

export default function AllCertifications() {
  const isMobile = useMediaQuery({ maxWidth: 768 });

  const sortCertifications = (certifications) => {
    const sortedCertifications = [...certifications];

    return sortedCertifications.sort((a, b) => {
      const dateComparison = new Date(b.issueDate) - new Date(a.issueDate);
      if (dateComparison === 0) {
        return a.title.localeCompare(b.title);
      } else {
        return dateComparison;
      }
    });
  };

  const renderCertificationsColumnName = () => {
    return (
      <div className="certifications-column-name">
        <div className="certifications-column-name__name">Name</div>
        <div className="certifications-column-name__organization">
          Organization
        </div>
        <div className="certifications-column-name__date">Date</div>
        <div className="certifications-column-name__link">Link</div>
      </div>
    );
  };

  const renderCertification = (certification) => {
    return isMobile ? (
      <CertificationCard certification={certification} />
    ) : (
      <div key={certification.id} className="certification">
        <div className="certification-title">{certification.title}</div>
        <div className="certification-issuer">{certification.issuer}</div>
        <div className="certification-issueDate">{certification.issueDate}</div>
        <div className="certification-credentialUrl">
          <a
            href={certification.credentialUrl}
            target="_blank"
            rel="noreferrer"
          >
            View Credential
            <FaExternalLinkAlt className="certification-external-icon" />
          </a>
        </div>
      </div>
    );
  };

  return (
    <DetailsLayout subtitle={"All Certifications"}>
      <div className="all-certifications-container">
        {!isMobile && renderCertificationsColumnName()}
        {[...sortCertifications(CERTIFICATIONS)].map(renderCertification)}
      </div>
    </DetailsLayout>
  );
}
